// src/pages/FAQ.js
import React, { useEffect, useState } from 'react';
import '../styles/faq.css';

export default function FaqCascada() {
    const [data, setData] = useState(null);      // { seoTitle, sectionTitle, ui, items: [...] }
    const [activo, setActivo] = useState(null);
    const [cargando, setCargando] = useState(true);
    const [error, setError] = useState(false);

    const base = process.env.PUBLIC_URL || '';
    const urlFAQ = `${base}/data/faq.json`;

    useEffect(() => {
        let cancel = false;
        (async () => {
            try {
                const r = await fetch(urlFAQ, { cache: 'no-store' });
                if (!r.ok) throw new Error('HTTP ' + r.status);
                const json = await r.json();
                if (cancel) return;
                setData(json);
                if (json?.seoTitle) document.title = json.seoTitle;
            } catch (e) {
                console.error('[FAQ] Error cargando', urlFAQ, e);
                if (!cancel) {
                    setError(true);
                    setData({
                        sectionTitle: 'Preguntas Frecuentes',
                        ui: {
                            loadingText: 'Cargando…',
                            loadError: 'No se pudo cargar la información...',
                            empty: 'Pronto agregaremos preguntas frecuentes.',
                            expandSymbol: '+',
                            collapseSymbol: '−',
                            expandAria: 'Expandir respuesta',
                            collapseAria: 'Colapsar respuesta',
                        },
                        items: [],
                    });
                }
            } finally {
                if (!cancel) setCargando(false);
            }
        })();
        return () => { cancel = true; };
    }, [urlFAQ]);

    const alternar = (id) => setActivo((prev) => (prev === id ? null : id));

    if (cargando || !data) {
        return (
            <section className="faq-wrapper seccion-fondo" aria-busy="true">
                <h1 className="titulo-faq">Preguntas Frecuentes</h1>
                <hr className="linea-separadora" />
                <p className="intro-faq">Cargando…</p>
            </section>
        );
    }

    if (error) {
        return (
            <section className="faq-wrapper seccion-fondo">
                <h1 className="titulo-faq">{data.sectionTitle || 'Preguntas Frecuentes'}</h1>
                <hr className="linea-separadora" />
                <p className="intro-faq" role="alert">{data.ui?.loadError || 'No se pudo cargar la información...'}</p>
            </section>
        );
    }

    const items = Array.isArray(data.items) ? data.items : [];

    return (
        <section className="faq-wrapper seccion-fondo" aria-labelledby="faq-heading">
            <h1 id="faq-heading" className="titulo-faq">{data.sectionTitle}</h1>
            <hr className="linea-separadora" />

            {items.length === 0 ? (
                <p className="intro-faq">{data.ui?.empty}</p>
            ) : (
                <div className="faq-lista" role="list">
                    {items.map(({ id, pregunta, respuesta }) => {
                        const abierto = activo === id;
                        const panelId = `faq-panel-${id}`;
                        const btnId = `faq-btn-${id}`;

                        return (
                            <article
                                key={id}
                                className={`faq-item ${abierto ? 'activo' : 'inactivo'}`}
                                role="listitem"
                            >
                                <h2 className="faq-encabezado">
                                    <button
                                        id={btnId}
                                        className="faq-toggle"
                                        aria-expanded={abierto}
                                        aria-controls={panelId}
                                        onClick={() => alternar(id)}
                                        aria-label={abierto ? data.ui?.collapseAria : data.ui?.expandAria}
                                    >
                                        <span className="faq-pregunta">{pregunta}</span>
                                        <span className="faq-icono" aria-hidden="true">
                                            {abierto ? data.ui?.collapseSymbol : data.ui?.expandSymbol}
                                        </span>
                                    </button>
                                </h2>

                                <div
                                    id={panelId}
                                    className="faq-respuesta"
                                    role="region"
                                    aria-labelledby={btnId}
                                    hidden={!abierto}
                                >
                                    {respuesta ? <p>{respuesta}</p> : null}
                                </div>
                            </article>
                        );
                    })}
                </div>
            )}
        </section>
    );
}
